/**
 * PricingPreview — 4-card price summary linking out to the full /pricing page.
 */
import { GlassButton } from '@/components/GlassButton';
import { Reveal } from '@/components/Reveal';
import { SectionHeading } from '@/components/SectionHeading';

interface Plan {
  name: string;
  price: string;
  cadence: string;
  blurb: string;
  highlight: boolean;
}

const PLANS: readonly Plan[] = [
  { name: '免费', price: '¥0',   cadence: '永久',     blurb: '基础玩法 · 10 课 · 2 单词本', highlight: false },
  { name: '月付', price: '¥29',  cadence: '/ 月',     blurb: '全库 · AI Pro · 无限',          highlight: false },
  { name: '季付', price: '¥78',  cadence: '/ 季 · 9折', blurb: '相当于 ¥26 / 月',              highlight: false },
  { name: '年付', price: '¥278', cadence: '/ 年 · 8折', blurb: '相当于 ¥23.17 / 月',           highlight: true  },
];

export function HomePricingPreview(): JSX.Element {
  return (
    <section className="relative py-24 md:py-32 border-t border-honey-400/10">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="Pricing · 透明定价"
            title={<>核心玩法 <span className="text-gradient-warm">永远免费</span></>}
            subtitle="只在你想解锁全库时才付钱 — 价格永远低于一杯咖啡"
          />
        </Reveal>
        <div className="mt-12 grid gap-4 md:grid-cols-4">
          {PLANS.map((p) => (
            <Reveal key={p.name}>
              <div className={`rounded-3xl border p-5 h-full ${p.highlight
                ? 'border-honey-400/50 bg-honey-400/[0.06] glow-cyan'
                : 'border-honey-400/15 bg-ink-900/40'}`}>
                <div className="text-xs font-arcade tracking-widest text-honey-300">{p.name}</div>
                <div className="mt-2 flex items-baseline gap-1">
                  <span className="font-display text-3xl font-extrabold text-white">{p.price}</span>
                  <span className="text-xs text-cream-400">{p.cadence}</span>
                </div>
                <div className="mt-3 text-xs text-cream-300/90 leading-relaxed">{p.blurb}</div>
              </div>
            </Reveal>
          ))}
        </div>
        <div className="mt-6 text-center">
          <GlassButton to="/pricing" size="md">查看完整对比 →</GlassButton>
        </div>
      </div>
    </section>
  );
}
